import React from 'react';
import { withRouter } from 'react-router-dom';
import { push } from 'connected-react-router';
import { closeAlert } from '../../actions/commonsActions';
import queryString from '../../helpers/query-string';
import connect from 'react-redux/es/connect/connect';
import { userConfirmation } from '../../actions/authActions';
import {
	FormGroup,
	Form,
	Row,
	Col,
	Input,
	Button, CardImg, CardBody, CardTitle, Card, CardSubtitle, Alert
} from 'reactstrap';

import img1 from '../../assets/images/logo-icon.png';
import img2 from '../../assets/images/big/auth-bg.jpg';

const sidebarBackground = {
	backgroundImage: "url(" + img2 + ")",
	backgroundRepeat: "no-repeat",
	backgroundPosition: "center center"
};

const alertStyle = {
	// position: 'relative',
	// top: '0',
	// right: '0'
	width: '40%'
}

class Confirmation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isShown: false,
			isConfirmed: false
		}
	}

	componentDidMount() {
		const parsedObj = queryString.parse(this.props.location.search);
		if (parsedObj && parsedObj.token) {
			this.props.userConfirmation(parsedObj.token)
				.then(res => {
					if (res.status === 'OK') {
						this.setState({
							isShown: true,
							isConfirmed: true
						})
					}
				})
		}
	}

	onLogin = () => {
		this.props.closeAlert();
		this.setState({
			isShown: false,
			isConfirmed: false
		});
		this.props.changeLocation('/');
	};

	render() {
		return <div style={{position: 'relative'}}>
			{/*----------------------- alerts -----------------------------------*/}
			<Alert
				style={alertStyle}
				color={`${this.props.alert.alert.status}`}
				isOpen={this.props.alert.isOpen || false}
			>
				{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
			</Alert>
					<div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
						{
							this.state.isShown ? (
								this.state.isConfirmed ? (
										<div className="auth-box">
											<CardTitle> Успешно </CardTitle>
											<Button color="primary" size="lg" type="button" block onClick={this.onLogin}> Логин </Button>
										</div>
									) : (
										<div className="auth-box">
											<CardTitle> Неудача </CardTitle>
										</div>
									)
							) : (
								<span></span>
							)
						}
					</div>
			{/*--------------------------------------------------------------------------------*/}
			{/*Recover Password Cards*/}
			{/*--------------------------------------------------------------------------------*/}
			{/*<div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
				<div className="auth-box">
					<div id="loginform">
						<div className="logo">
							<span className="db"><img src={img1} alt="logo" /></span>
							<h5 className="font-medium mb-3">Recover Password</h5>
						</div>
						<Row>
							<Col xs="12">
								<Form className="mt-3" id="loginform" action="/dashbaord">
									<FormGroup>
										<Input type="text" name="uname" bsSize="lg" id="uname" placeholder="Name" required />
									</FormGroup>
									<FormGroup>
										<Input type="email" name="emailid" bsSize="lg" id="uname" placeholder="Email" required />
									</FormGroup>
									<Row className="mb-4">
										<Col xs="12">
											<Button color="primary" size="lg" type="submit" className="text-uppercase" block>Reset</Button>
										</Col>
									</Row>
								</Form>
							</Col>
						</Row>
					</div>
				</div>
			</div> */}
		</div>;
	}
}

const mapDispatchToProps = dispatch => {
	return {
		changeLocation: (url) => dispatch(push(url)),
		closeAlert: () => dispatch(closeAlert()),
		userConfirmation: token => dispatch(userConfirmation(token))
	};
};

const mapStateToProps = state => ({
	alert: state.alert
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Confirmation));



// WEBPACK FOOTER //
// ./src/views/authentication/confirmation.jsx